// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var PrescriberLicenseType;
(function (PrescriberLicenseType) {
    PrescriberLicenseType[PrescriberLicenseType["UNKNOWN"] = 0] = "UNKNOWN";
    PrescriberLicenseType[PrescriberLicenseType["DRUGENFORCEMENTADMINISTRATIONNUMBER"] = 1] = "DRUGENFORCEMENTADMINISTRATIONNUMBER";
    PrescriberLicenseType[PrescriberLicenseType["STATELICENSEID"] = 2] = "STATELICENSEID";
    PrescriberLicenseType[PrescriberLicenseType["MEDICAIDID"] = 3] = "MEDICAIDID";
    PrescriberLicenseType[PrescriberLicenseType["STATETAXID"] = 4] = "STATETAXID";
})(PrescriberLicenseType || (PrescriberLicenseType = {}));
//# sourceMappingURL=prescriberLicenseType.js.map